export const authUrl = "https://auth0302.herdnavigatorlive.com/token";
